import { Directive } from '@angular/core';
import { LayoutElementDirective } from './layout-element.directive';

@Directive({
  selector: '[am-layout-main]',
})
export class LayoutMainDirective extends LayoutElementDirective {
}
